<template>
  <div class="text-center">
    <v-progress-circular class="mt-6" :width="2" :size="50" color="primary" indeterminate />
  </div>
</template>

<script>
export default { name: 'UIProgressCircular' }
</script>
